import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import { LeftArrowIcon } from "@/components/confluence/icons";
import { ConfluenceTemplateMessages } from "@/components/confluence/templates/template-messages";
import { ConfluenceTemplateAnalytics } from "@/components/confluence/templates/util/confluence-templates-analytics";
import { useTemplates } from "@/content/templates/template.provider";
import { wacToken } from "@/libraries/design/foundations";
import { useLocalizedHref } from "@/libraries/web-framework";

import { TemplateCategorySection } from "../template-details-page/template-category-section.tsx";
import { TemplateHeaderSection } from "../template-details-page/template-header-section.tsx";
import TemplateKeyFeaturesSection from "../template-details-page/template-key-features-section.tsx";

import { TemplateDetailsBodyCfind3646 } from "./cfind3646-exp-template-details-body.tsx";

const detailPageStyles = css({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    paddingInlineStart: "16px",
    paddingInlineEnd: "16px"
});

const detailPageContentStyles = css({
    display: "flex",
    gap: "31px",
    justifyContent: "center",
    maxWidth: "100%",
    [media.below.sm]: {
        flexDirection: "column"
    }
});

const backLinkStyles = css({
    color: wacToken("color.neutral.light200"),
    fontSize: "16px",
    fontWeight: "500",
    letterSpacing: "-0.2px",
    maxWidth: "1166px",
    padding: "56px 0px 56px 0px",
    width: "100%"
});

const leftSectionStyles = css({
    display: "flex",
    flexDirection: "column",
    width: "368px",
    paddingBlockStart: "68px",
    marginBlockStart: "-68px",
    height: "100%",
    insetBlockStart: 0,
    [media.below.sm]: {
        height: "auto",
        paddingInlineStart: "16px",
        paddingInlineEnd: "16px",
        position: "relative",
        width: "100%"
    },
    [media.above.sm]: {
        position: "sticky"
    }
});

const rightSectionStyles = css({
    display: "flex",
    flexDirection: "column",
    paddingBlockStart: "136px",
    width: "767px",
    [media.below.sm]: {
        paddingInlineStart: "16px",
        paddingInlineEnd: "16px",
        paddingBlockStart: "0",
        width: "100%"
    }
});

export const DetailPageContentCfind3646 = () => {
    const templates = useTemplates();
    const template = templates[0];

    const intl = useIntl();
    const templatesLink = useLocalizedHref("/software/confluence/templates");

    const linkText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.backLink.cfind.1508",
        defaultMessage: "Explore all Confluence templates"
    });

    const backAriaLabel =
        ConfluenceTemplateMessages.searchBackAriaLabel.defaultMessage;

    if (!template) {
        return null;
    }

    return (
        <div data-testid="confluence-template-details-page">
            <div css={detailPageStyles}>
                <div css={detailPageContentStyles}>
                    <div css={leftSectionStyles}>
                        <div css={backLinkStyles}>
                            <a
                                href={templatesLink}
                                aria-label={backAriaLabel}
                                {...ConfluenceTemplateAnalytics.searchBackButton()}
                            >
                                <LeftArrowIcon size="13" />
                                {linkText}
                            </a>
                        </div>
                        <TemplateHeaderSection template={template} />
                        <TemplateKeyFeaturesSection template={template} />
                        <TemplateCategorySection template={template} />
                    </div>
                    <div
                        css={rightSectionStyles}
                        data-testid="TemplateDetailsBody-top"
                    >
                        <TemplateDetailsBodyCfind3646 template={template} />
                    </div>
                </div>
            </div>
        </div>
    );
};
